import type { ReactNode } from 'react'

/**
 * Рендерит текст комментария с подсвеченными @-меншенами.
 * Регулярка ловит `@<имя>` где имя — буквы (включая кириллицу), цифры,
 * подчёркивание и точка/тире, либо «Имя Фамилия» (два слова через пробел).
 *
 * Не парсит и не сравнивает с реальными user-id — это просто визуал.
 * Список реально упомянутых лежит в comment.mentions, но для подсветки
 * текста его сейчас не используем (избегаем O(n²) поиска).
 */
const MENTION_RE = /@([\wА-Яа-яЁё-]+(?:\s[\wА-Яа-яЁё-]+)?)/g

export function MentionText({ text }: { text: string }) {
  const parts: ReactNode[] = []
  let last = 0
  let match: RegExpExecArray | null
  MENTION_RE.lastIndex = 0
  while ((match = MENTION_RE.exec(text))) {
    if (match.index > last) parts.push(text.slice(last, match.index))
    parts.push(
      <span key={`m-${match.index}`} className="text-brand-600 font-medium">
        @{match[1]}
      </span>,
    )
    last = match.index + match[0].length
  }
  if (last < text.length) parts.push(text.slice(last))
  return <>{parts}</>
}
